import { useEffect, useState } from 'react';
import { Undo2 } from 'lucide-react';
import { useStore } from '../store';
import { salesCrmApi } from '../services/salesCrmApi';
import { leadGenApi } from '../services/leadGenApi';
import { ApiError } from '../services/api';

// ADR 0371: nach dem Speichern eines Anruf-Ergebnisses im neuen Abschluss-Fenster bleibt für ein paar Sekunden dieser
// Streifen. „Rückgängig“ setzt den Stand zurück (Server) und öffnet das Abschluss-Fenster für dasselbe Gespräch
// wieder, damit das richtige Ergebnis gleich gewählt ist. Discord-Meldung und Aufnahme bleiben, wie sie sind.
export function RueckgaengigStreifen() {
  const a = useStore((s) => s.letzterAbschluss);
  const vergiss = useStore((s) => s.vergissAbschluss);
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    setFehler(null);
    if (!a) return;
    const t = window.setTimeout(vergiss, Math.max(0, a.bis - Date.now()));
    return () => window.clearTimeout(t);
  }, [a, vergiss]);

  useEffect(() => {
    if (!fehler) return;
    const t = window.setTimeout(() => { setFehler(null); vergiss(); }, 6000);
    return () => window.clearTimeout(t);
  }, [fehler, vergiss]);

  if (!a) return null;

  const zuruecknehmen = async () => {
    setLaeuft(true); setFehler(null);
    try {
      await salesCrmApi.callRueckgaengig(a.callId);
      if (a.defekt) {                                  // der Defekt-Vermerk gehört zum Ergebnis, das jetzt zurückgenommen ist
        for (const phoneKey of a.defekt.phoneKeys) {
          try {
            await leadGenApi.setPhoneDefect(a.defekt.leadId, {
              personKey: a.defekt.personKey, central: a.defekt.central, phoneKey, reason: null,
            });
          } catch { /* der Rest ist zurückgenommen, ein hängender Vermerk lässt sich an der Nummer aufheben */ }
        }
      }
      const s = useStore.getState();
      s.vergissAbschluss();
      if (s.callViewOpen) s.endCall();                 // z. B. das Mail-Fenster nach dem Speichern steht noch
      s.setzeKorrektur({ callId: a.callId, kommentar: a.kommentar });
      s.startCall(a.lead, undefined, a.wahl);
    } catch (e) {
      setFehler(e instanceof ApiError && e.detail && typeof e.detail.text === 'string'
        ? e.detail.text : 'Rückgängig ging nicht.');
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 rounded-lg border
                    border-emerald-500/40 bg-bg-secondary px-3 py-2 text-sm text-emerald-200 shadow-lg"
         data-testid="rueckgaengig">
      {fehler
        ? <span className="text-rose-300">{fehler}</span>
        : <span>✓ Gespeichert: {a.ergebnis}</span>}
      {!fehler && (
        <button onClick={() => void zuruecknehmen()} disabled={laeuft}
                className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg border border-border-primary
                           bg-bg-tertiary text-xs font-semibold text-text-main hover:bg-bg-elevated disabled:opacity-40">
          <Undo2 size={13} /> Rückgängig
        </button>
      )}
    </div>
  );
}
